import { 
    InvoicesService, 
    InvoiceUpdate, 
    InvoiceResponse,
    OrderUpdate,
    UserOrderResponse,
    OrdersService,
    InvoiceCommercialUpdate,
    InvoiceCommercialResponse,
    InvoiceCommercialService,
    OrderItemsService,
    OrderItemResponse,
    OrderItemBulkUpsertRequest,
    InvoicePaymentScheduleService,
    PaymentScheduleResponse,
    PaymentScheduleBulkUpsert
} from "@/api";


export const AdminOrderUpdateService = {
    async update_order(
        orderId: number,
        order: OrderUpdate
    ): Promise<UserOrderResponse> {
        return OrdersService.updateOrderOrdersAdminIdPut(
            orderId,
            order
        );
    },

    async upsert_order_items(
        orderId: number,
        orderItems: OrderItemBulkUpsertRequest
    ): Promise<OrderItemResponse[]> {
        return OrderItemsService.bulkUpsertOrderItemsOrdersOrderIdItemsPut(
            orderId,
            orderItems
        );
    },

    async updateInvoice(
        invoiceId: number,
        invoice: InvoiceUpdate
    ): Promise<InvoiceResponse> {
        return InvoicesService.adminUpdateInvoiceInvoicesInvoiceIdPatch(
            invoiceId,
            invoice
        );
    },

    async approveInvoice(
        invoiceId: number,
    ): Promise<InvoiceResponse> {
        return InvoicesService.approveInvoiceEndpointInvoicesInvoiceIdApprovePost(
            invoiceId,
        );
    },

    async updateInvoiceCommercial(
        invoiceCommercialId: number,
        payload: InvoiceCommercialUpdate
    ): Promise<InvoiceCommercialResponse> {
        return InvoiceCommercialService.updateInvoiceCommercialInvoicesCommercialsIdPut(
            invoiceCommercialId,
            payload
        );
    },

    async upsert_payment_schedules(
        invoiceId: number,
        paymentSchedules: PaymentScheduleBulkUpsert
    ): Promise<PaymentScheduleResponse[]> {
        return InvoicePaymentScheduleService
            .bulkUpsertPaymentSchedulesInvoicesPaymentSchedulesInvoicesInvoiceIdPaymentSchedulesPut(
                invoiceId,
                paymentSchedules
            );
    },
};